import { useState } from 'react';
import ViewControls from './view-controls';
import ListView from './list-view';
import ByProductView from './by-product-view';

const ShoppingList = ({ basket, items, ingredients }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [view, setView] = useState('list');

	const itemCount = items.filter((item) => item !== null).length;
	const hasItems = itemCount > 0;
	return (
		<>
			<div className={`shopping-list ${isOpen ? 'is-open' : ''}`}>
				<button
					className="shopping-list__toggle"
					onClick={() => setIsOpen(!isOpen)}
				>
					<img
						className="icon"
						src={'./assets/icon--shopping-list.svg'}
						alt="Shopping List"
						title="Shopping List"
						/>
					{hasItems && (
						<span className="shopping-list__count">{itemCount < 100 ? itemCount : '99+'}</span>
					)}
				</button>
				<h3>Shopping List:</h3>
				<ViewControls view={view} setView={setView} />
				{!hasItems && (
					<p>---</p>
				)}
				{hasItems && (
					<>
						<div className={view === 'list' ? 'shopping-list-wrapper' : 'hidden'}>
							<ListView items={items} />
						</div>
						<div className={view === 'by-product' ? 'shopping-list-wrapper' : 'hidden'}>
							<ByProductView basket={basket} ingredients={ingredients} />
						</div>
					</>
				)}
			</div>
			{isOpen && (
				<div className={`shopping-list__overlay`} onClick={() => setIsOpen(false)} />
			)}
		</>
	)
};

export default ShoppingList;
